//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';

export default {
  name: 'Role',

  data() {
    return {
      CDN: process.env.CDN,
      REGION: process.env.REGION,
      activeRole: 1,
      webmSrc: `${process.env.CDN}/feature/feature_status_1.webm`,
      mp4Src: `${process.env.CDN}/feature/feature_status_1.mp4`,
    };
  },

  computed: {
    ...mapState(['features', 'isMobile']),
    ...mapGetters(['imgSuffix']),
    roleList() {
      const roles = [...Array(this.features.roleCount).keys()].map(
        (el) => el + 1,
      );
      let roleList = [];
      let count = 4;
      let tempRole = [];

      roles.forEach((role, index) => {
        tempRole = [...tempRole, role];
        count -= 1;
        if (count === 0 || index === roles.length - 1) {
          roleList = [...roleList, tempRole];
          tempRole = [];
          count = 4;
        }
      });

      return roleList;
    },
  },

  methods: {
    handleBtnRoleClick(role) {
      this.activeRole = role;
      this.webmSrc = `${this.CDN}/feature/feature_status_${role}.webm`;
      this.mp4Src = `${this.CDN}/feature/feature_status_${role}.mp4`;
      this.$refs.featureVideo.load();
      this.$refs.featureVideo.play();
    },
  },
};
